import script from "./IfcViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcViewer.vue?vue&type=script&setup=true&lang=ts"

import "./IfcViewer.vue?vue&type=style&index=0&id=0b03296d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b03296d"]])

export default __exports__